import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
   name: 'formatMailboxTypes',
   standalone: false,
})
export class FormatMailboxTypesPipe implements PipeTransform {
   private readonly mailboxTypeMap: Record<string, string> = {
      VoiceMailbox: 'Voicemail Only',
      SmartVoicemail: 'Smart Voicemail',
   };

   transform(type: string | null | undefined): string {
      if (!type) return '';

      return this.mailboxTypeMap[type] ?? type;
   }
}
